export enum ProjectsActionTypes {
  SetProjects = 'SetProjects',
  SetRates = 'SetRates',
  SetSwapFee = 'SetSwapFee',
  SetEnvelopeId = 'SetEnvelopeId',
  SetWhitelistedAddresses = 'SetWhitelistedAddresses',
}
